"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Card = require("material-ui/Card");

var _assetsVisualization = require("./assets-visualization");

var _assetsVisualization2 = _interopRequireDefault(_assetsVisualization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(_Card.CardHeader, { showExpandableButton: true, actAsExpander: true, subtitle: "Webpack Assets" });

var WebpackAssets = function WebpackAssets(props) {
  return _react2.default.createElement(
    _Card.Card,
    { initiallyExpanded: true },
    _ref,
    _react2.default.createElement(
      _Card.CardText,
      { expandable: true },
      _react2.default.createElement(_assetsVisualization2.default, { assets: props.webpackInfo.assets })
    )
  );
};
WebpackAssets.propTypes = {
  assets: _react.PropTypes.array
};

exports.default = WebpackAssets;


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/components/sub-components/assets.js
// module id = 496
// module chunks = 0